import { render } from "./ReportBookingsView.vue?vue&type=template&id=25a71252"
import script from "./ReportBookingsView.vue?vue&type=script&lang=js"
export * from "./ReportBookingsView.vue?vue&type=script&lang=js"

import "./ReportBookingsView.vue?vue&type=style&index=0&id=25a71252&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__